<template>
  <RastreoEnvio
    titulo="Rastreo Local"
    icono="bi bi-pin-map"
    subtitulo="Consulta el estado, los datos y las evidencias de un envío local."
    ejemplo="ANW-L-00003659"
    endpoint="tracking-local"
    campo-estado="estado_entrega"
    campo-estado-archivo="id_estados_envio_local"
    :pasos="pasos"
    :paso-entregado="6"
    :especiales="especiales"
    :datos="datos"
  />
</template>

<script>
import RastreoEnvio from '@/components/RastreoEnvio.vue'

// Estados de envíos locales (tabla estados_envio_local)
const PASOS = [
  { ids: [1],     titulo: 'Solicitud Recibida',          icono: 'bi bi-inbox' },
  { ids: [2],     titulo: 'Solicitud Aprobada',          icono: 'bi bi-check2-square' },
  { ids: [3],     titulo: 'Programado para Ruta',        icono: 'bi bi-signpost-split' },
  { ids: [4, 11], titulo: 'En Recojo',                   icono: 'bi bi-truck' },
  { ids: [5],     titulo: 'Recojo Finalizado / En Ruta', icono: 'bi bi-truck-front' },
  { ids: [6],     titulo: 'Llegada a Destino',           icono: 'bi bi-geo-alt' },
  { ids: [7],     titulo: 'Entrega Finalizada',          icono: 'bi bi-box-seam' },
  { ids: [8],     titulo: 'Cargo PDF Subido',            icono: 'bi bi-file-earmark-arrow-up' },
  { ids: [9],     titulo: 'Cargo Físico Entregado',      icono: 'bi bi-envelope-check' },
  { ids: [10],    titulo: 'Estado Documentario',         icono: 'bi bi-file-earmark-text' },
]

const ESPECIALES = {
  13: { texto: 'Servicio rechazado', color: 'naranja', icono: 'bi bi-slash-circle-fill' },
  15: { texto: 'Servicio cancelado', color: 'roja', icono: 'bi bi-x-circle-fill' },
}

export default {
  name: 'TrackingLocalPage',
  components: { RastreoEnvio },
  data() {
    return { pasos: PASOS, especiales: ESPECIALES }
  },
  methods: {
    datos(e, f) {
      return [
        { etiqueta: 'Origen', icono: 'bi bi-box-arrow-up-right', valor: f.empresaSucursal(e.empresa_sucursal), ancho: true },
        { etiqueta: 'Destino', icono: 'bi bi-geo', valor: f.empresaSucursal(e.empresa_sucursal_destino), detalle: e.ubicacion_destinatario, ancho: true },
        { etiqueta: 'Salida', icono: 'bi bi-calendar-event', valor: f.unir(f.fecha(e.fecha_salida), f.hora(e.hora_salida)) },
        { etiqueta: 'Entrega', icono: 'bi bi-calendar-check', valor: f.unir(f.fecha(e.fecha_entrega), f.hora(e.hora_llegada_destino)) },
        { etiqueta: 'Guía de remisión', icono: 'bi bi-receipt', valor: e.guias_concatenadas },
        { etiqueta: 'Pedido / OC', icono: 'bi bi-bag', valor: f.unir(e.pedidos_concatenados, e.oc_concatenadas) },
        { etiqueta: 'Unidad y personal', icono: 'bi bi-truck', valor: f.unir(e.unidad_asignada, e.personal) },
        { etiqueta: 'Bultos', icono: 'bi bi-boxes', valor: e.cant_bultos },
      ]
    },
  },
}
</script>
